module.exports = __webpack_public_path__ + "img/6_161.ed188316.png";